//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ApartmentForm",
  props: ["isVisible", "apartment", "choices", "totalPrice", "isLight"],
  methods: {
    handleFormClose() {
      this.$emit("closeForm");
    }
  },
  updated() {
    let form = document.querySelector(`.apartment-form form.wpcf7-form`);
    wpcf7.init(form);
    $("#houseSelection").val(this.apartment);
    if ($("#houseAttributes").length > 0) {
      let attributes = `Kolor: ${this.isLight ? "jasny" : "ciemny"} \n`;
      this.choices.forEach(item => {
        attributes += `${item.details.name} - ${item.counter} \n`;
      });
      $("#houseAttributes").val(attributes);
    }

    if ($("#houseTotal").length > 0) {
      $("#houseTotal").val(this.totalPrice);
    }
    jQuery(".apartment-form form.wpcf7-form").each(function() {
      $(this)
        .find("span.ajax-loader")
        .last()
        .remove();
    });
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/partials/ApartmentForm.vue